/**
 * SGKE902A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface SupplystopresumptionResultInfo {

    /**
     * 呼び出し元機能区分
     */
    callmotoFuncDiv?: string;
    /**
     * 供給地点特定番号
     */
    suppntSpno?: string;
    /**
     * 供給停止再開履歴番号
     */
    supplystopresumptionRrkno?: string;
    /**
     * 更新通番号
     */
    updateSrno?: string;
    /**
     * 使用者お客さま漢字氏名
     */
    userName?: string;
    /**
     * 請求先名
     */
    visitName?: string;
    /**
     * 作業場所コード
     */
    workPlaceCode?: string;
    /**
     * 供給停止結果区分コード
     */
    supplystopResultDivcd?: string;
    /**
     * 供給再開結果区分コード
     */
    supplyresumptionResultDivcd?: string;
    /**
     * 作業日時(変更前)
     */
    workTimeBf?: string;
    /**
     * 作業日時(変更後)
     */
    workTimeAf?: string;
    /**
     * 作業時間帯
     */
    workTimezone?: string;
}

